

















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import Role from "@/models/security/role.model";
import ListaRoles from "@/modules/security/roles/lista.vue";
import ListaPermisos from "@/modules/security/roles/permisos.vue";

@Component({
  components: { ListaRoles, ListaPermisos }
})
export default class Roles extends Vue {
  @Prop() public usuarioId!: number;
  @Prop() public title!: string;

  isLoading = false;
  rolSelected = new Role();

  selectRole(rol: Role) {
    this.rolSelected = rol;
  }
  rolUpdate() {
    (this.$refs.listaRoles as ListaRoles).getRoles();
  }

  @Watch("usuarioId")
  onDepChange(value: number) {
    this.rolSelected = new Role();
  }

  created() {
  }
}
